// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { stimulusApplication as application } from "packages/web"

import AnimationComponentController from "./animation_component_controller"
application.register("animation-component", AnimationComponentController)

import CodeInputComponentController from "./code_input_component_controller"
application.register("code-input-component", CodeInputComponentController)

import DialogComponentController from "./dialog_component_controller"
application.register("dialog-component", DialogComponentController)

import FileFieldComponentController from "./file_field_component_controller"
application.register("file-field-component", FileFieldComponentController)

import TypeformWidgetComponentController from "./typeform_widget_component_controller"
application.register("typeform-widget-component", TypeformWidgetComponentController)
